import { RestRequest, RestContext, ResponseFunction } from 'msw'
import {
  addToEntityListData,
  updateEntityListData,
  deleteEntityListData,
} from '../../modules/mockDataCommon'
import { requireAuthenticatedUser } from '../../decorators'
import { getMeetingListData } from './mockData'
import type { IMeeting } from '~/types/meeting/models'

interface GetMeetingsResponse {
  data: IMeeting[]
}

async function getMeetings(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  console.log(`'Returning meetings.`)
  const responseBody: GetMeetingsResponse = { data: await getMeetingListData() }
  return res(ctx.status(200), ctx.json(responseBody))
}

// post

const postMeeting = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return addToEntityListData(req, res, ctx, getMeetingListData)
}

const patchMeeting = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return updateEntityListData(req, res, ctx, getMeetingListData)
}

const deleteMeeting = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return deleteEntityListData(req, res, ctx, getMeetingListData)
}

export const handlers = [
  {
    method: 'get',
    path: '/api/meetings',
    handler: getMeetings,
  },
  {
    method: 'post',
    path: '/api/meetings',
    handler: postMeeting,
  },
  {
    method: 'patch',
    path: '/api/meetings/:id',
    handler: patchMeeting,
  },
  {
    method: 'delete',
    path: '/api/meetings/:id',
    handler: deleteMeeting,
  },
].map((h) => ({ ...h, ...{ handler: requireAuthenticatedUser(h.handler) } }))
